export default "__VITE_ASSET__C35AOzEc__"